import apiFetch from '../apiFetch'

export default function (token, code) {
  return apiFetch({ endPoint: `DocumentTypeUse/Id?code=${code}`, method: 'GET', body: null, token: token })
}
